import { Input, Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LinkComponent {
  @Input() routerLink: string;
  @Input() queryParams: {
    [k: string]: any;
  };

  @Input() useButtonLook: boolean;
  @Input() useButtonRaisedLook: boolean;
  @Input() buttonColor: string;

  constructor(private router: Router) {}

  private getQueryAsString(): string {
    let query = '';
    for (const key of Object.keys(this.queryParams)) {
      const value = this.queryParams[key];
      query += query.length ? '&' : '?';
      query += key + '=' + value;
    }
    return query;
  }

  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.ctrlKey || e.metaKey || e.button === 1) {
      window.open(this.routerLink + this.getQueryAsString(), '_blank');
    } else if (e.button !== 2) {
      const queryParams = this.queryParams;
      this.router.navigate([this.routerLink], { queryParams });
    }
  }
}
